import {Component, OnDestroy} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs/internal/Subscription";
import {LocalStorage} from "src/app/services/local-storage";
import {ModalPaymentService} from "src/app/services/ux/modal-payment.service";
import {toastrService} from "src/app/services/ux/toastr.service";
import {WalletService} from "src/app/services/wallet.service";
import {Ukt} from "src/app/models/SearchService/ukt.model";
import {Ukd} from "src/app/models/SearchService/ukd.model";
import {UkHttpClientService} from "src/app/data/uk-http-client.service";
import {finalize} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";

@Component({
    templateUrl: "uk-search.component.html"
})
export class UkSearchComponent implements OnDestroy {
    // #region Subscriptions
    subscription: Subscription;
    ccSubscription: Subscription;
    finishTransactionSubscription: Subscription;
    // #endregion

    searchForm: FormGroup;

    isLoading = false;

    hasResults = false;

    ukCities = []
    private _records: Ukt[] | Ukd[] = [] as Ukd[] | Ukt[];
    public get records(): Ukt[] | Ukd[] {
        return this._records;
    }

    public set records(v: Ukt[] | Ukd[]) {
        this._records = v;
        this.hasResults = !!v.length;
    }

    selectedCity = null
    hasParam = false;

    selectedInvoice: any = [];
    invoiceIndex: number;

    isUkd = false;

    // readonly cities = [
    //     {city: "Tirane", cityCode: "UKT"},
    //     {city: "Divjake", cityCode: "UKDI"},
    //     {city: "Lushnje", cityCode: "UKLU"},
    //     {city: "Himare", cityCode: "UKHI"},
    //     {city: "Kukes", cityCode: "UKKU"},
    //     {city: "Mat", cityCode: "UKMA"},
    //     {city: "Roskovec", cityCode: "UKRV"},
    //     {city: "Kruje", cityCode: "UKKR"},
    //     {city: "Devoll", cityCode: "UKDV"},
    //     {city: "Kavaje", cityCode: "UKKV"},
    //     {city: "Shkoder", cityCode: "UKSH"},
    //     {city: "Elbasan", cityCode: "UKEL"},
    //     {city: "Pogradec", cityCode: "UKPG"},
    //     {city: "Fier", cityCode: "UKFR"},
    //     {city: "Korce", cityCode: "UKKO"},
    //     {city: "Shijak", cityCode: "UKSHI"},
    //     {city: "Vlore", cityCode: "UKVLORE"},
    //     {city: "Durres", cityCode: "UKD"},
    //     {city: "Berat", cityCode: "UKBR"}
    // ];

    constructor(
        private fb: FormBuilder,
        private toastr: toastrService,
        private walletService: WalletService,
        private route: ActivatedRoute,
        private modalService: ModalPaymentService,
        private ls: LocalStorage,
        private ukDataService: UkHttpClientService,
        private translateService: TranslateService
    ) {
        this.searchForm = this.fb.group({
            contractNumber: [""],
            institutionCode: [undefined]
        });

        this.subscription = walletService.$walletReadyEmitter.subscribe(
            (isReady: boolean) => {
                if (isReady) {
                    this.processUkTransaction();
                }
            }
        );

        this.finishTransactionSubscription = walletService.$transactionFinish.subscribe(
            (value) => {
                if (value) {
                    this.removeFinishedTransactionFromRecords();
                }
            }
        );

        this.ccSubscription = walletService.$creditCardReadyEmitter.subscribe(
            (ccSelected) => {
                if (ccSelected) {
                    this.processUkTransaction(ccSelected);
                }
            }
        );

      
    }

    ngOnInit() {
        this.getUkCities().then(() => {

        this.route.params.subscribe((params: any) => {
            this.isLoading = true
            try {
                this.ukDataService.GetUkCities().subscribe(data => {
                    const ukCities = data.map((c: any) => ({
                        city: c.cityName,
                        cityCode: c.cityCode,
                        wsEnpoint: c.wsEndpoint
                    }));
    
                    this.ukCities = ukCities;

                    if (params.contractNumber) {
                        this.searchForm.controls["contractNumber"].setValue(
                            params.contractNumber
                        );
                        const paramCityCode = params.institutionCode;
        
                        let institutionCodeSelectObj;
                        this.ukCities.forEach((city) => {
                            if (city.cityCode === paramCityCode) {
                                institutionCodeSelectObj = city;
                            }
                        });
        
                        this.searchForm.controls["institutionCode"].setValue(
                            institutionCodeSelectObj
                        );
                        this.hasParam = true;
                        this.onSearch();
                    }
                })
            } catch (err) {
                this.toastr.error(err.response && err.response.data || err.message)
            }
            this.isLoading = false


        });
    })

    }

    async getUkCities() {
        this.isLoading = true
        try {
            this.ukDataService.GetUkCities().subscribe(data => {
                const ukCities = data.map((c: any) => ({
                    city: c.cityName,
                    cityCode: c.cityCode,
                    wsEnpoint: c.wsEndpoint
                }))

                this.ukCities = ukCities

                // this.searchForm = this.fb.group({
                //     contractNumber: [""],
                //     institutionCode: [this.ukCities[0]]
                // });
            })
        } catch (err) {
            this.toastr.error(err.response && err.response.data || err.message)
        }
        this.isLoading = false
    }

    onSearch() {
        this.isLoading = true;

        const selectedCityName = this.searchForm.value.institutionCode.city;
        const existCity = this.ukCities.find(c => c.city === selectedCityName)
        const contractValue = this.searchForm.value.contractNumber;

        if (!existCity || !contractValue) {
            this.toastr.warning(this.translateService.instant("Services.FillInContractNumber"));
            this.isLoading = false;
            return;
        }

        if (
            existCity.wsEnpoint === 'ukd'
        ) {
            this.isUkd=true;
            this.ukDataService
                .SearchUkd(contractValue, existCity.cityCode)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: (res: Ukd[]) => {
                        this.records = res;
                    },
                    error: (error: HttpErrorResponse) => {
                        this.records = [] as Ukd[] | Ukt[];
                        if (error.error === "contract_not_found") {
                            this.toastr.warning(this.translateService.instant("Services.ContractNotFound"));
                        }
                        if (error.error === "no_invoices") {
                            this.toastr.warning(this.translateService.instant("Services.NoInvoiceWasFound"));
                        }
                        if (error.error === "uk_search_failed") {
                            this.toastr.warning(this.translateService.instant("Services.SearchFailed"));
                        }
                    }
                });
        } else {
            this.isUkd=false;
            this.ukDataService
                .SearchUkt(contractValue, existCity.cityCode)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: (res: Ukt[]) => {
                        this.records = res;
                    },
                    error: (error: HttpErrorResponse) => {
                        if (error.error === "contract_not_found") {
                            this.toastr.warning(this.translateService.instant("Services.ContractNotFound"));
                        }
                        if (error.error === "no_invoices") {
                            this.toastr.warning(this.translateService.instant("Services.NoInvoiceWasFound"));
                        }
                        if (error.error === "uk_search_failed") {
                            this.toastr.warning(this.translateService.instant("Services.SearchFailed"));
                        }
                    }
                });
        }
        this.selectedCity = existCity
    }

    onPayUK(index) {
        this.invoiceIndex = index;
        this.selectedInvoice = this.records[index];

        this.walletService.selectInvoice(this.selectedInvoice);

        this.walletService.amountOfTransaction = !!this.selectedCity && this.selectedCity.wsEnpoint === 'ukd' ?
            this.selectedInvoice.total_no_vat +
            this.selectedInvoice.total_vat -
            this.selectedInvoice.amount_payed +
            this.selectedInvoice.total_interest_overdue +
            this.selectedInvoice.komision :
            this.selectedInvoice.invoice + this.selectedInvoice.interest + this.selectedInvoice.komision;

        this.modalService.open();
    }

    processUkTransaction(creditCardMethod: boolean = false) {
        const ukInvoice = {
            invoice: this.walletService.getInvoice(),
            serviceFields: [
                {
                    FieldName: "contractNumber",
                    FieldValue: this.searchForm.value.contractNumber
                },
                {
                    FieldName: "city",
                    FieldValue: this.searchForm.value.institutionCode.cityCode
                }
            ],
            ipAddress: "127.0.0.1",
            deviceId: "EternaWebPosta"
        };

        if (creditCardMethod) {
            if (!!this.selectedCity && this.selectedCity.wsEnpoint === 'ukd') {
                this.ukDataService.PayUkdCC(ukInvoice).subscribe({
                    next: (res) => {
                        if (!res.data) {
                            this.walletService.emitTransactionProgress({
                                isSuccess: false,
                                error: res.error.message
                            }
                            );
                            return;
                        }
                        this.walletService.emitTransactionProgress(
                            {
                                isSuccess: true,
                                error: null
                            }
                        );
                        this.ls.set("sn", "ukt/ukd");
                        window.location = (res.data.redirect);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
            } else {
                this.ukDataService.PayUktCC(ukInvoice).subscribe({
                    next: (res) => {
                        if (!res.data) {
                            this.walletService.emitTransactionProgress({
                                isSuccess: false,
                                error: res.error.message
                            }
                            );
                            return;
                        }
                        this.walletService.emitTransactionProgress(
                            {
                                isSuccess: true,
                                error: null
                            }
                        );
                        this.ls.set("sn", "ukt/ukmun");
                        window.location = (res.data.redirect);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
            }
        } else {
            if (!!this.selectedCity && this.selectedCity.wsEnpoint === 'ukd') {
                this.ukDataService.PayUkdWallet(ukInvoice).subscribe({
                    next: () => {
                        const emmiterObject = {
                            isSuccess: true,
                            error: null
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
            } else {
                this.ukDataService.PayUktWallet(ukInvoice).subscribe({
                    next: () => {
                        const emmiterObject = {
                            isSuccess: true,
                            error: null
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
            }
        }
    }

    private removeFinishedTransactionFromRecords() {
        this.records.splice(this.invoiceIndex, 1);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.ccSubscription.unsubscribe();
        this.finishTransactionSubscription.unsubscribe();
    }
}
